import { ApiResource } from 'app/services/api/enums';
import { ApiRequestHandler } from 'app/services/api/interfaces';
import { AxiosRequestConfig } from 'axios';
import { toastSuccess } from 'modules/utils';

import { apiService } from './api';
import { buildApiPath } from './utils';

export interface UrlParams {
  resource: ApiResource;
  urlPrefix?: string;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface ApiRequest<ResponseDto, RequestDto> {
  params: AxiosRequestConfig & UrlParams;
  handlers?: ApiRequestHandler<ResponseDto>;
  successRequestMessage?: string;
  rejectOnCancel?: boolean;
}

export const apiRequestCall = <ResponseDto, RequestDto = Record<string, unknown>>({
  params,
  handlers: { success = () => null, error = () => null } = {},
  rejectOnCancel = true,
  successRequestMessage = '',
}: ApiRequest<ResponseDto, RequestDto>): Promise<ResponseDto> => {
  const url = buildApiPath(params.resource, params.urlPrefix);

  return apiService
    .request({ url, ...params })
    .then((payload) => {
      if (successRequestMessage) {
        toastSuccess(successRequestMessage);
      }

      success(payload.data.responseData);

      return payload.data.responseData;
    })
    .catch((err) => {
      error(err);

      if (!rejectOnCancel) {
        return Promise.resolve();
      }

      return Promise.reject(err);
    });
};
